import { Box, Breadcrumbs, Link as MuiLink, Typography, useTheme } from "@mui/material";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function PageLayout({ icon, pageTitle, children, breadCrumbs, customComponent }) {
    const theme = useTheme();

    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
        },
        title: {
            flex: '0 1 auto',
            marginTop: 0,
            marginBottom: 0,
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            fontSize: { xs: '1.5rem', md: '2rem' },
        },
        icon: {
            color: theme.palette.primary.light,
            marginRight: '.75rem'
        }
    };

    const CustomBreadCrumbs = () => {
        const crumbs = breadCrumbs ?? [];

        if (crumbs.length === 0) {
            return (
                <Breadcrumbs separator="›" aria-label="breadcrumb">
                    <Typography sx={{ color: 'text.primary', textAlign: 'left' }}>{pageTitle}</Typography>
                </Breadcrumbs>
            );
        }

        return (
            <Breadcrumbs separator="›" aria-label="breadcrumb">
                <MuiLink component={Link} underline="hover" color="inherit" to="/">
                    Painel
                </MuiLink>
                {crumbs.map((obj, index) => (
                    <MuiLink key={index} component={Link} underline="hover" color="inherit" to={obj.path}>
                        {obj.label}
                    </MuiLink>
                ))}
                <Typography sx={{ color: 'text.primary', textAlign: 'left' }}>{pageTitle}</Typography>
            </Breadcrumbs>
        );
    };

    const PageTitle = () => {

        return (
            <Typography sx={styles.title} variant="h1">
                {icon && <Box component={icon} sx={styles.icon} />}
                {pageTitle}
            </Typography>
        );
    };

    return (
        <>
            <Helmet>
                <title>{pageTitle}</title>
            </Helmet>
            <Box sx={styles.container}>
                <CustomBreadCrumbs />

                <Box
                    display="flex"
                    sx={{
                        flexDirection: { xs: 'column', lg: 'row' },
                        justifyContent: 'space-between',
                        alignItems: { xs: 'stretch', lg: 'center' },
                        gap: 2,
                        mt: 1,
                        mb: 3,
                    }}
                >
                    <PageTitle />
                    {customComponent ? customComponent() : null}
                </Box>

                <Box sx={{ minWidth: 0, width: '100%' }}>{children}</Box>
            </Box>
        </>
    );
};
